import * as api from './api';
import * as types from './mutations';

const state = {
    isProcessing: false,
    fetchedCourses: [],
    paginator: {},
    cached: false,
    orderBy: 'title'
};

const actions = {
    /**
     * Check if member has already added course into his wishlist.
     *
     * @param type
     * @param id
     * @returns {Promise}
     */
    checkIfAddedToWishlist({}, {type, id}) {
        return new Promise((resolve, reject) => {
            axios.get(api.checkIfAdded(type, id))
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response))
        });
    },

    /**
     * Get member wishlist.
     *
     * @param commit
     * @param state
     * @param params
     * @returns {Promise}
     */
    getItems({commit, state}, params) {
        return new Promise((resolve, reject) => {
            if (state.cached) return resolve(state.fetchedCourses);

            commit(types.SET_PROCESSING_STATE, true);
            axios.get(api.getWishlistItems(params))
                .then(({data}) => {
                    // We merge fetched courses with saved courses
                    // when user click view more button.
                    const courses = params.page === 1
                        ? data.wishlist.data
                        : _.uniqBy([...state.fetchedCourses, ...data.wishlist.data], course => course.id);

                    commit(types.UPDATE_FETCHED_COURSES, courses);
                    commit(types.UPDATE_PAGINATOR, data.wishlist.meta.pagination);
                    commit(types.SET_CACHED_STATE, true);

                    resolve(data.wishlist.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    /**
     * Add item to member wishlist
     *
     * @param commit
     * @param item [Course]
     * @param wishlistType [currently support course only]
     * @returns {Promise}
     */
    addItem({commit}, {item, wishlistType}) {
        // We should reset wishlist state so when member always get his updated wishlist.
        commit(types.SET_CACHED_STATE, false);
        commit(types.UPDATE_FETCHED_COURSES, []);
        commit(types.UPDATE_PAGINATOR, {});

        return new Promise((resolve, reject) => {
            axios.post(api.addToWishlist, {item, wishlistType})
                .then(({data}) => resolve(data))
                .catch(({response}) => reject(response));
        });
    },

    /**
     * Remove item from member wishlist.
     *
     * @param commit
     * @param dispatch
     * @param state
     * @param removedItem
     * @returns {Promise}
     */
    removeItem({commit, dispatch, state}, {removedItem}) {
        // Currently removing wishlist item is available only with Course model
        // We can set model dynamically in the future if needed.
        return new Promise((resolve, reject) => {
            axios.delete(api.removeFromWishlist('course', removedItem.id))
                .then(() => {
                    const remainingCourses = state.fetchedCourses.filter(course => course.id !== removedItem.id);
                    commit(types.UPDATE_FETCHED_COURSES, remainingCourses);

                    dispatch('getItems',
                        {
                            page: state.paginator.current_page - 1 || 1,
                            limit: state.paginator.per_page,
                            orderBy: state.orderBy
                        }
                    );
                })
                .catch(({response}) => reject(response));
        });
    },
};

const mutations = {
    [types.UPDATE_PAGINATOR](state, paginator) {
        state.paginator = paginator;
    },

    [types.UPDATE_FETCHED_COURSES](state, courses) {
        state.fetchedCourses = courses;
    },

    [types.SET_CACHED_STATE](state, isCached) {
        state.cached = isCached;
    },

    [types.SET_ORDER_BY](state, criteria) {
        state.orderBy = criteria;
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};